//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ProjectClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type DeleteProjectQueryParameters = {
  id?: number | undefined ;
}

export type SearchProjectQueryParameters = {
  search?: string | null | undefined ;
  requiredResource?: Types.ProjectResourceType | null | undefined ;
  requiredOperation?: Types.OperationType | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type PatchProjectQueryParameters = {
  id: number ;
}

export type GetProjectQueryParameters = {
  id: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/projects";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'ProjectClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.ProjectDto, unknown, Types.CreateProjectDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProjectDto, unknown, Types.CreateProjectDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateProjectDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function deleteUrl(id?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/projects?";
if (id === null)
    throw new Error("The parameter 'id' cannot be null.");
else if (id !== undefined)
    url_ += "id=" + encodeURIComponent("" + id) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteMutationKey(id?: number | undefined): MutationKey {
  return trimArrayEnd([
      'ProjectClient',
      'delete',
      id as any,
    ]);
}

export function useDeleteMutation<TContext>(id?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.delete_(id),
    mutationKey: key,
  });
}
  
type Delete__MutationParameters = DeleteProjectQueryParameters

export function useDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Delete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteProjectQueryParameters}): UseMutationResult<void, unknown, Delete__MutationParameters, TContext> {
  const key = deleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Delete__MutationParameters) => Client.delete_(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function searchUrl(search?: string | null | undefined, requiredResource?: Types.ProjectResourceType | null | undefined, requiredOperation?: Types.OperationType | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/projects?";
if (search !== undefined && search !== null)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
if (requiredResource !== undefined && requiredResource !== null)
    url_ += "RequiredResource=" + encodeURIComponent("" + requiredResource) + "&";
if (requiredOperation !== undefined && requiredOperation !== null)
    url_ += "RequiredOperation=" + encodeURIComponent("" + requiredOperation) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfProjectListItemDto, unknown, Types.PagedResultOfProjectListItemDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfProjectListItemDto, unknown, Types.PagedResultOfProjectListItemDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchProjectQueryParameters): QueryKey;
export function searchQueryKey(search?: string | null | undefined, requiredResource?: Types.ProjectResourceType | null | undefined, requiredOperation?: Types.OperationType | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { search, requiredResource, requiredOperation, offset, limit, sortBy, sortOrder,  } = params[0] as SearchProjectQueryParameters;

    return trimArrayEnd([
        'ProjectClient',
        'search',
        search as any,
        requiredResource as any,
        requiredOperation as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'ProjectClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as Types.ProjectResourceType | null | undefined,       context.queryKey[4] as Types.OperationType | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as string | null | undefined,       context.queryKey[8] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfProjectListItemDto, TError = unknown>(dto: SearchProjectQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfProjectListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param search (optional) 
 * @param requiredResource (optional) When specified, only projects where the current user has the required permission for this resource are returned.
 * @param requiredOperation (optional) Used together with RequiredResource to filter projects by the current user's permissions.
 * @param offset (optional) 
 * @param limit (optional) 
 * @param sortBy (optional) 
 * @param sortOrder (optional) 
 */
export function useSearchQuery<TSelectData = Types.PagedResultOfProjectListItemDto, TError = unknown>(search?: string | null | undefined, requiredResource?: Types.ProjectResourceType | null | undefined, requiredOperation?: Types.OperationType | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfProjectListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfProjectListItemDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfProjectListItemDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let search: any = undefined;
  let requiredResource: any = undefined;
  let requiredOperation: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ search, requiredResource, requiredOperation, offset, limit, sortBy, sortOrder,  } = params[0] as SearchProjectQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [search, requiredResource, requiredOperation, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfProjectListItemDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(search, requiredResource, requiredOperation, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfProjectListItemDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param search (optional) 
 * @param requiredResource (optional) When specified, only projects where the current user has the required permission for this resource are returned.
 * @param requiredOperation (optional) Used together with RequiredResource to filter projects by the current user's permissions.
 * @param offset (optional) 
 * @param limit (optional) 
 * @param sortBy (optional) 
 * @param sortOrder (optional) 
 */
export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfProjectListItemDto | undefined) => Types.PagedResultOfProjectListItemDto, search?: string | null | undefined, requiredResource?: Types.ProjectResourceType | null | undefined, requiredOperation?: Types.OperationType | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(search, requiredResource, requiredOperation, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * @param search (optional) 
 * @param requiredResource (optional) When specified, only projects where the current user has the required permission for this resource are returned.
 * @param requiredOperation (optional) Used together with RequiredResource to filter projects by the current user's permissions.
 * @param offset (optional) 
 * @param limit (optional) 
 * @param sortBy (optional) 
 * @param sortOrder (optional) 
 */
export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfProjectListItemDto | undefined) => Types.PagedResultOfProjectListItemDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/projects/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'ProjectClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.ProjectDto, unknown, Types.PatchProjectDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProjectDto, unknown, Types.PatchProjectDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchProjectDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchProjectQueryParameters & {
  dto: Types.PatchProjectDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.ProjectDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchProjectQueryParameters}): UseMutationResult<Types.ProjectDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function getUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/projects/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.ProjectDto, unknown, Types.ProjectDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ProjectDto, unknown, Types.ProjectDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(id: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetProjectQueryParameters;

    return trimArrayEnd([
        'ProjectClient',
        'get',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'ProjectClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.ProjectDto, TError = unknown>(dto: GetProjectQueryParameters, options?: Omit<UseQueryOptions<Types.ProjectDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.ProjectDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.ProjectDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.ProjectDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ProjectDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetProjectQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ProjectDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(id),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.ProjectDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.ProjectDto | undefined) => Types.ProjectDto, id: number) {
  queryClient.setQueryData(getQueryKey(id),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ProjectDto | undefined) => Types.ProjectDto) {
  queryClient.setQueryData(queryKey, updater);
}